/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { capitalize } from 'lodash'

import type { EuiBadgeProps } from '@elastic/eui'
import { EuiBadge } from '@elastic/eui'

import type { SaasLevel } from '@modules/ui-types'

import type { FunctionComponent } from 'react'

type Props = {
  level: SaasLevel
}

type SaasLevelBadgeColorMap = {
  [level in SaasLevel]: EuiBadgeProps['color']
}

const saasLevelBadgeColorMap: SaasLevelBadgeColorMap = {
  standard: `primary`,
  gold: `warning`,
  platinum: `default`,
  enterprise: `success`,
}

const fallbackColor = `hollow`

const OrganizationSubscriptionLevelBadge: FunctionComponent<Props> = ({ level }) => (
  <EuiBadge color={saasLevelBadgeColorMap[level] || fallbackColor}>{capitalize(level)}</EuiBadge>
)

export default OrganizationSubscriptionLevelBadge
